import * as Yup from 'yup';
import { yupToFormErrors } from 'formik';
import moment from 'moment';
import { getTranslatedString } from 'helpers/i18n';

export const validateForm = async (values) => {
  let validationSchema = {
    lease_start_date: Yup.string().required(
      getTranslatedString('landlordPortal.leaseCreatorV2.leaseDetailsPage.leaseStartDateIsRequired')
    ),
    lease_end_date: Yup.string()
      .required(
        getTranslatedString('landlordPortal.leaseCreatorV2.leaseDetailsPage.leaseEndDateIsRequired')
      )
      .test(
        'lease_end_date',
        getTranslatedString(
          'landlordPortal.leaseCreatorV2.leaseDetailsPage.leaseEndDateMustBeAfterStartDate'
        ),
        (value) => {
          if (!value) return false;
          return !moment(value).isBefore(values.lease_start_date);
        }
      ),
    early_move_in_date: values.early_move_in_date_toggle
      ? Yup.string()
          .required(
            getTranslatedString(
              'landlordPortal.leaseCreatorV2.leaseDetailsPage.earlyMoveInDateIsRequired'
            )
          )
          .test(
            'early_move_in_date',
            getTranslatedString(
              'landlordPortal.leaseCreatorV2.leaseDetailsPage.earlyMoveInDateMustBeBeforeStartDate'
            ),
            (value) => {
              if (!value) return false;
              if (moment(value).isSame(values.lease_start_date)) return true;

              return moment(value).isBefore(values.lease_start_date);
            }
          )
      : Yup.string(),
    property_id: Yup.string().required(
      getTranslatedString('landlordPortal.leaseCreatorV2.leaseDetailsPage.propertyIsRequired')
    ),
    unit_type_id: values.delay_unit_assignment
      ? Yup.string().required(
          getTranslatedString('landlordPortal.leaseCreatorV2.leaseDetailsPage.unitTypeIsRequired')
        ).nullable()
      : Yup.string().nullable(),
    unit_id: !values.delay_unit_assignment
      ? Yup.string().required(
          getTranslatedString('landlordPortal.leaseCreatorV2.leaseDetailsPage.unitIsRequired')
        ).nullable()
      : Yup.string().nullable(),
    document_template_id: Yup.string().required(
      getTranslatedString(
        'landlordPortal.leaseCreatorV2.leaseDetailsPage.baseLeaseTemplateIsRequired'
      )
    ),
  };
  const schema = Yup.object().shape(validationSchema);
  return schema.validate(values, { abortEarly: false }).catch((error) => {
    throw yupToFormErrors(error);
  });
};
